<template>
  <div
    data-component="base-item"
    :class="componentStates"
    @click="onClick"
  >
    <base-item-info
      :person="person"
      :avatar="avatar"
      :icon="icon"
      :size="size"
      :title="title"
      :description="description"
      :status="status"
      :status-type="statusType"
      :is-disabled="isDisabled"
    />

    <component
      :is="actionsComponentType"
      v-if="actions && actions.length"
      :actions="actions"
      :size="size"
      :description="actionsDescription"
      :show-action-icons="showActionIcons"
      :is-disabled="isDisabled"
      @action-click="$emit('action-click', $event)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';

import BaseItemInfo from './BaseItemInfo.vue';
import BaseItemActionsInline from './BaseItemActionsInline.vue';
import BaseItemActionsPopup from './BaseItemActionsPopup.vue';
import {
  AVATAR_PROP,
  PERSON_PROP,
  SIZE_PROP,
  ITEM_ACTIONS_PROP,
  ITEM_ACTIONS_DISPLAY_PROP,
} from '../../constants';

export default defineComponent({
  name: 'BaseItem',
  components: {
    BaseItemInfo,
    BaseItemActionsInline,
    BaseItemActionsPopup,
  },
  props: {
    avatar: AVATAR_PROP,
    person: PERSON_PROP,
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    statusType: {
      type: String,
      default: '',
    },
    actions: ITEM_ACTIONS_PROP,
    actionsType: ITEM_ACTIONS_DISPLAY_PROP,
    actionsDescription: {
      type: String,
      default: '',
    },
    size: SIZE_PROP,
    showActionIcons: Boolean,
    isClickable: Boolean,
    isDisabled: Boolean,
  },
  emits: ['item-click', 'action-click'],
  computed: {
    componentStates() {
      return {
        'is-disabled': this.isDisabled,
        'is-clickable': this.isClickable,
      };
    },

    actionsComponentType() {
      return this.actionsType === 'popup'
        ? BaseItemActionsPopup
        : BaseItemActionsInline;
    },
  },
  methods: {
    onClick() {
      if (this.isClickable) {
        this.$emit('item-click');
      }
    },
  },
});
</script>

<style lang="scss" scoped>
[data-component='base-item'] {
  display: flex;
  padding: var(--s-3) var(--s-5);

  &.is-clickable {
    cursor: pointer;
  }

  &:hover:not(.is-disabled) {
    background: var(--or-c-primary-opacity-0-08);
  }

  [data-component='base-item-info'] {
    flex: 1 1 100%;
    margin-right: var(--s-4);
  }

  [data-component='base-item-actions-inline'],
  [data-component='base-item-actions-popup'] {
    flex: 0 0 auto;
    max-width: calc(50% - 1rem);
    margin-left: auto;
  }
}
</style>
